import { SeeMyTrainingRequestsDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'

import { RequestsComponent } from 'modules/trainings/components/MyTrainings/RequestsComponent'

const Requests = () => {
  const { loading, data } = useQuery(SeeMyTrainingRequestsDocument)
  const seeCatalog = !!data?.trainings._policies.trainingsSeeCatalog.can

  if (loading) return <></>

  return (
    <AuthorizeUser authorizeFn={() => seeCatalog}>
      <RequestsComponent />
    </AuthorizeUser>
  )
}

export default Requests
